import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-healthcare-provider',
  templateUrl: './healthcare-provider.component.html',
  styleUrls: ['./healthcare-provider.component.css']
})
export class HealthcareProviderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}